import http from '@common/oneclub/services/http'

export interface BasicUserInfo {
  email: string
  phone: string
  oneshipName: string
  countryCode: string
  areaCode: string
  acceptMarketing: boolean
}

// 获取账号信息
export const getBasicUserInfo = () => http.normal.post<BasicUserInfo>('/api/user/info/get-basic')

interface EditBasicUserInfoParams {
  oneshipName: string
  acceptMarketing: boolean
}

// 账号信息编辑
export const editBasicUserInfo = (params: EditBasicUserInfoParams) => http.normal.post('/api/user/info/update-basic', params)
